import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { GetTransportAreasParams, SaveTransportAreaResponse, TransportAreaItem, TransportAreaService } from '@app/services/transport-area.service';

@Component({
    selector: 'tt-transport-areas',
    templateUrl: './transport-areas.component.html',
    styleUrls: ['./transport-areas.component.css'],
})
export class TransportAreasComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetTransportAreasParams;

    public areas?: TransportAreaItem[];

    public selectedId?: string;

    constructor(
        private transportArea: TransportAreaService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public async openAddModal() {
        if (!this.params) return;

        const response: SaveTransportAreaResponse | undefined = await this.modal.openStateDialog({ state: 'transportarea', params: `0/${this.params.stockplace_id}` });

        if (!!response) {
            await this.loadAreas();
            this.selectedId = response.transportarea_keyno;
        }
    }

    public onTransportAreaSubmitted(event: { type: 'delete' | 'save' }) {
        this.loadAreas();

        if (event.type === 'delete') {
            delete this.selectedId;
        }
    }

    private async loadAreas(): Promise<void> {
        delete this.areas;

        if (!!this.params) {
            this.areas = await this.transportArea.getTransportAreaItems({ ...this.params, add_unused_postplaces: '1' });
        }
    }

    private async init() {
        this.loadAreas();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.navigator.setHeading?.('p2_m_transportareas', true);
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transportAreas', {
//        templateUrl: 'views/components/views/transportAreas/transportAreas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'transportAreasService', function ($stateParams, stateService, transportAreasService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;

//            vm.model = {
//                itemsListAreas: []
//            };

//            // #endregion LOAD PROCEDURE CALL

//            async function loadAreas() {
//                vm.model.itemsListAreas = (await transportAreasService.listAreas({ stockplace_id: stockPlaceId }));
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'transportarea':
//                        go({
//                            transportarea_keyno: '0',
//                            stockplace_id: stockPlaceId
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadAreas();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
